// HTMLVideoElement.prototype.playBackwards = function () {
//   if (!this.paused) {
//     this.pause();
//   }
//   let video = this;
//   let fps = 30;
//   let intervalRewind = setInterval(function () {
//     if (video.currentTime <= 0) {
//       clearInterval(intervalRewind);
//       video.pause();
//     } else {
//       video.currentTime -= 1 / fps;
//     }
//   }, 1000 / fps);
// };

HTMLVideoElement.prototype.playBackwards = function () {
  if (!this.paused) {
    this.pause();
  }

  const video = this;
  const initialPlaybackRate = video.playbackRate; // Store original playback rate
  const stepIntervalMs = 40; // Milliseconds per step - a smaller interval for smoother steps
  const timeStep = stepIntervalMs / 1000; // Time in seconds to step back

  // Clear any existing backward intervals
  if (video._backwardInterval) {
    clearInterval(video._backwardInterval);
  }

  video._backwardInterval = setInterval(function () {
    if (video.currentTime <= timeStep) {
      // If we're near or at the beginning, stop and set to 0
      video.currentTime = 0;
      clearInterval(video._backwardInterval);
      video._backwardInterval = null;
      video.pause();
    } else {
      video.currentTime -= timeStep;
    }
  }, stepIntervalMs);

  // Optionally, listen for manual pauses to clear the interval
  const onPause = () => {
    if (video._backwardInterval) {
      clearInterval(video._backwardInterval);
      video._backwardInterval = null;
      video.removeEventListener('pause', onPause);
    }
  };
  video.addEventListener('pause', onPause);
};

class Zone {
  constructor(el) {
    this.videoPlayable = true;
    this.videoDirection = 1;
    this.hotspot = el;
    this.sceneHotspots = document.getElementById("hotspots");
    this.zone = this.hotspot.getAttribute("data-hotspot");
    this.zoneVideo = document.getElementById(`zoneVideo${this.zone}`);
    this.zoneContent = document.getElementById(`zoneContent${this.zone}`);
    this.zoneBackButton = this.zoneContent.querySelector("[data-back]");
    this.buttonHome = document.getElementById("showCampusButton");
    this.init();
  }
  init() {
    this.zoneVideo.addEventListener("timeupdate", this.timeUpdateHandler.bind(this));
    this.zoneVideo.addEventListener("ended", this.endedHandler.bind(this));
    this.hotspot.addEventListener("click", this.clickHandler.bind(this));
    this.zoneBackButton.addEventListener("click", this.backHandler.bind(this));
  }
  clickHandler(e) {
    this.buttonHome.disabled = true;
    this.zoneVideo.classList.remove("hidden", "opacity-0", "pointer-events-none");
    this.sceneHotspots.classList.add("hidden", "opacity-0", "pointer-events-none");
    this.zoneVideo.play();
  }
  endedHandler(e) {
    if (this.videoDirection == 1) {
      this.buttonHome.disabled = false;
      this.zoneContent.classList.remove("hidden", "opacity-0", "pointer-events-none");
    }
  }
  backHandler(e) {
    this.buttonHome.disabled = true;
    this.zoneContent.classList.add("hidden", "opacity-0", "pointer-events-none");
    this.videoDirection = -1;
    this.zoneVideo.playBackwards();
  }
  timeUpdateHandler(e) {
    if (window.debug) { console.log(`Zone video playing created. ${e.target.currentTime}`); }
    if (e.target.currentTime <= 0 && this.videoDirection == -1) {
      this.buttonHome.disabled = false;
      this.zoneVideo.classList.add("hidden", "opacity-0", "pointer-events-none");
      this.sceneHotspots.classList.remove("hidden", "opacity-0", "pointer-events-none");
      this.videoDirection = 1;
    }
  }
}

export { Zone };
